export const DETAIL_ZOOM = 17

function getComparableDistance(distance) {
  return distance != null ? parseInt(distance, 10) : Number.POSITIVE_INFINITY
}

function selectStopsByGrid(stops, map, cellSizePx) {
  const grid = new Map()

  stops.forEach(stop => {
    const lat = Number(stop.lat)
    const lng = Number(stop.lng)
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return

    const point = map.latLngToContainerPoint([lat, lng])
    const key = `${Math.floor(point.x / cellSizePx)}:${Math.floor(point.y / cellSizePx)}`

    if (!grid.has(key)) {
      grid.set(key, stop)

      return
    }

    const currentStop = grid.get(key)
    if (getComparableDistance(stop.distance) < getComparableDistance(currentStop.distance)) {
      grid.set(key, stop)
    }
  })

  return Array.from(grid.values())
}

export function clusterGridSize(zoom) {
  if (zoom <= 12) return 90
  if (zoom === 13) return 80
  if (zoom === 14) return 70
  if (zoom === 15) return 60
  if (zoom === 16) return 45

  return 24
}

export function aggregateStopsByZoom(stops, options = {}) {
  const {
    map,
    zoom,
    selectedStop,
    selectedStopCandidates = stops,
    detailZoom = DETAIL_ZOOM
  } = options

  if (!map || !Array.isArray(stops) || !stops.length) return stops

  const currentZoom = zoom == null ? map.getZoom() : zoom
  if (currentZoom >= detailZoom) return stops

  let aggregatedStops = selectStopsByGrid(
    stops,
    map,
    clusterGridSize(currentZoom)
  )

  if (selectedStop && selectedStop.id) {
    const selectedIsVisible = aggregatedStops.some(stop => stop.id === selectedStop.id)
    if (!selectedIsVisible) {
      const selected = selectedStopCandidates.find(stop => stop.id === selectedStop.id)
      if (selected) aggregatedStops = [selected, ...aggregatedStops]
    }
  }

  return aggregatedStops
}
